var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.category
    ? _c(
        "div",
        { staticClass: "rsp2CategoryPageNavi" },
        [
          _vm.parentCategory
            ? _c("h2", {
                domProps: { innerHTML: _vm._s(_vm.parentCategory.title) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rsp2Header" },
            [
              _c("h1", { domProps: { innerHTML: _vm._s(_vm.category.title) } }),
              _vm._v(" "),
              (_vm.pages && _vm.pages.length > 0) ||
              (_vm.assistants && _vm.assistants.length > 0)
                ? [
                    _c("DropPop", {
                      attrs: {
                        label: "Sortieren nach",
                        items: _vm.sortByItems
                      },
                      on: {
                        select: function(item) {
                          _vm.setSort(item.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("GridLayout", {
                      attrs: { name: "category" },
                      on: {
                        select: function(layout) {
                          _vm.contentClass = layout
                        }
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.pagesLoaded &&
          _vm.assistantsLoaded &&
          (!_vm.pages || _vm.pages.length === 0) &&
          (!_vm.assistants || _vm.assistants.length === 0)
            ? [
                _c("p", { staticClass: "rsp2Empty" }, [
                  _vm._v("Diese Inhalte befinden sich noch im Aufbau.")
                ])
              ]
            : [
                _c("section", [
                  _c("h3", {
                    staticClass: "visuallyhidden",
                    domProps: { innerHTML: _vm._s(_vm.category.title) }
                  }),
                  _vm._v(" "),
                  _vm.pagesLoaded
                    ? _c(
                        "ul",
                        {
                          class: ((_obj = { rsp2Content: true }),
                          (_obj[_vm.contentClass] = true),
                          _obj)
                        },
                        [
                          _vm.pages && _vm.pages.length > 0
                            ? _vm._l(_vm.pages, function(page) {
                                return _c("CategoryNaviItem", {
                                  key: page.id,
                                  staticClass: "rsp2Item",
                                  attrs: {
                                    title: page.title,
                                    description: page.teaser,
                                    url: page.url,
                                    tags: page.tags,
                                    showArrow: true,
                                    showDescription:
                                      _vm.contentClass == "rsp2List",
                                    termPath: _vm.termPath,
                                    hatching:
                                      page.majorVersion % 1 !== 0 ||
                                      !page.public,
                                    size: "s"
                                  }
                                })
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.assistants && _vm.assistants.length > 0
                  ? _c("section", [
                      _c("h4", [_vm._v("Assistenten")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          class: ((_obj$1 = { rsp2Content: true }),
                          (_obj$1[_vm.contentClass] = true),
                          _obj$1)
                        },
                        _vm._l(_vm.assistants, function(assistant) {
                          return _c("CategoryNaviItem", {
                            key: assistant.id,
                            staticClass: "rsp2Item",
                            attrs: {
                              title: assistant.title,
                              description: assistant.teaser,
                              url: assistant.url,
                              showArrow: true,
                              showDescription: _vm.contentClass == "rsp2List",
                              termPath: _vm.termPath,
                              hatching:
                                assistant.majorVersion % 1 !== 0 ||
                                !assistant.public,
                              size: "s"
                            }
                          })
                        })
                      )
                    ])
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm.termNotFound
    ? _c("div", { staticClass: "rsp2NotFound" }, [
        _c("p", [_vm._v("Die Kategorie konnte nicht gefunden werden.")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }